module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Chair2-2b3ff021d015caa8a846d326a2210618.svg";